var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBatsman = function SvgBatsman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#625BF6",
    clipPath: "url(#batsman_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.134 3.982 9.092 6.908l2.926-2.042.986-.986-.884-.884zM12.473 2.645l1.149-1.15.884.884-1.15 1.15zM15.567.433a.624.624 0 0 0-.884 0l-.708.707.884.885.708-.707a.625.625 0 0 0 0-.885"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.105 5.413 8.227 8.12a.25.25 0 0 1-.348-.348l2.706-3.878-.627-.1a1 1 0 0 0-.863.281L.47 12.7a.75.75 0 0 0 0 1.06l1.767 1.77a.75.75 0 0 0 1.06 0l8.626-8.625a1 1 0 0 0 .28-.863z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "batsman_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgBatsman;